<template>
  <div>
    <v-container class="pa-0" fluid>
      <!-- Toolbar -->
      <v-row style="height: 48px; max-height: 48px">
        <ContenidoBase
          :EstadoBtn="EstadoBtn"
          :descripcion="'Crear, Modificar y Desactivar Turnos'"
          :show-absolute="false"
          :titulo="'Turnos'"
          @MethodEliminar="eliminar"
          @MethodGuardar="guardar"
          @MethodNuevo="newwnuevo"
          @abrirBarraTablaDinamica="abrirTabla"
        />
      </v-row>
      <!-- fn Toolbar  -->

      <v-row>
        <!-- Barra de busqueda --->
        <v-col
          v-show="showBarraPrimaria"
          class="pr-0"
          cols="3"
          style="max-height: calc(100vh - 48px - 57px - 64px); overflow-y: scroll"
        >
          <v-tooltip left>
            <template v-slot:activator="{ on }">
              <BarraDinamicaLimitePlus
                :ContListSlot="[
                  { Text: 'Descripcion', NomValue: 'descripcion', Ctsl: 1, Type: 0, State: true },
                  { Text: 'Entrada', NomValue: 'horaEntrada', Ctsl: 1, Type: 4, State: true },
                  { Text: 'Salida', NomValue: 'horaSalida', Ctsl: 1, Type: 4, State: true },
                ]"
                :PropsList="turnoList"
                :PropsNombre="'Turnos'"
                :PropsSeachNombre="'Búsqueda por descripcion'"
                :TbPaginator="paginador"
                :TbTotalItem="totalItems"
                :headers="[]"
                props-search
                @CargarPaginacion="cargarPaginacion"
                @EmitDAta="datostabla"
              />
            </template>
          </v-tooltip>
        </v-col>
        <!-- fn Barra de busqueda --->

        <!-- Contenido central --->
        <v-col style="max-height: calc(100vh - 48px - 57px - 64px); overflow-y: scroll">
          <div class="px-2">
            <v-card color="grey lighten-3">
              <div class="px-2">
                <v-form ref="form" lazy-validation @submit.prevent="">
                  <v-row>
                    <!-- Columna 1--->
                    <v-col cols="12" md="6" sm="6">
                      <!-- Descripcion --->
                      <v-text-field
                        v-model="turno.descripcion"
                        :rules="[$rules.required]"
                        autocomplete="off"
                        dense
                        label="Descripción"
                        outlined
                        required
                      >
                        <template v-slot:prepend>
                          <i class="fa fa-font" style="font-size: 20px; width: 20px"></i>
                        </template>
                      </v-text-field>

                      <!-- Hora de entrada --->
                      <v-text-field
                        v-model="turno.horaEntrada"
                        autocomplete="off"
                        dense
                        label="Hora Entrada:"
                        outlined
                        type="time"
                      >
                        <template v-slot:prepend>
                          <i class="fa fa-clock-o" style="font-size: 20px; width: 20px"></i>
                        </template>
                      </v-text-field>
                    </v-col>
                    <!-- Fin columna 1 --->

                    <!-- Columna 2 --->
                    <v-col cols="12" md="6" sm="6">
                      <div class="ml-7" style="height: 66px">
                        <h4><strong>Selecciones Los Dias:</strong></h4>

                        <v-btn-toggle v-model="turno.dias" dense multiple>
                          <v-btn v-for="dia in diaSemanaList" :key="dia.dia" :value="dia" small>
                            <b>{{ dia.abreviatura }}</b>
                          </v-btn>
                        </v-btn-toggle>
                      </div>

                      <!-- Hora de salida --->
                      <v-text-field
                        v-model="turno.horaSalida"
                        autocomplete="off"
                        dense
                        label="Hora Salida:"
                        outlined
                        type="time"
                      >
                        <template v-slot:prepend>
                          <i class="fa fa-clock-o" style="font-size: 20px; width: 20px"></i>
                        </template>
                      </v-text-field>
                    </v-col>
                    <!-- fn columna 2 ---------------------------------------------->
                  </v-row>
                </v-form>
              </div>
            </v-card>
          </div>
        </v-col>
        <!-- fn Contenido central --->
      </v-row>
    </v-container>

    <!-- Modales -------------------------------------------------------------------------------------------------->

    <!------------otras funciones---------------->
    <v-snackbar
      v-model="aalert.estado"
      :color="aalert.color"
      :timeout="120000"
      :vertical="true"
      style="margin-top: 20%"
      top="top"
    >
      {{ aalert.nombre }}
      <v-btn dark text @click="aalert.estado = false">Close</v-btn>
    </v-snackbar>

    <!-- fn Modales ----------------------------------------------------------------------------------------------->
  </div>
</template>

<script>
  import BarraBusqueda2 from "../../components/BarraBusquedaDinam"
  import ContenidoBase from "../../components/ContenidoBase"
  import BarraDinamicaLimitePlus from "@/components/BarraDinamicaLimitePlus.vue"

  export default {
    components: {
      BarraDinamicaLimitePlus,
      BarraBusqueda2,
      ContenidoBase,
    },

    mounted() {
      this.findAllDias()
    },

    data() {
      return {
        windowSize: { width: "auto", height: "auto" },

        newTurno: {
          activo: true,
          borrado: false,
          codigo: 0,
          descripcion: "",
          horaEntrada: null,
          horaSalida: null,
          dias: [],
        },

        turno: {
          activo: true,
          borrado: false,
          codigo: 0,
          descripcion: "",
          horaEntrada: null,
          horaSalida: null,
          dias: [],
        },

        turnoList: [],
        diaSemanaList: [],

        descripcion: "",

        totalItems: 0,
        paginador: {
          page: 1,
          itemsPerPage: 5,
          pageStart: 1,
          pageStop: 15,
          pageCount: 10,
          itemsLength: 5,
        },
        showBarraPrimaria: false,

        aalert: {
          estado: false,
          color: null,
        },

        EstadoBtn: {
          BarraTablaDinamicaAprir: true,
          nuevo: true,
          guardar: true,
          eliminar: false,
          anular: false,
        },
      }
    },

    methods: {
      abrirTabla() {
        this.showBarraPrimaria = !this.showBarraPrimaria
      },

      datostabla(e) {
        Object.assign(this.turno, e)
        // Asignar referencia en memoria de dias cargados
        this.turno.dias = this.turno.dias.map((turnoDia) => this.diaSemanaList.find((dia) => dia.dia === turnoDia.dia))
      },

      newwnuevo() {
        Object.assign(this.turno, this.newTurno)
      },

      guardar() {
        if (this.$refs.form.validate()) {
          if (this.turno.codigo === 0) {
            this.save()
          } else {
            this.modify()
          }
        } else {
          this.alerta("Los campos en rojo son requeridos", "error")
        }
      },

      save() {
        this.$axios
          .post(this.$hostname + this.$hName + "/turnos-trabajo", this.turno, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((response) => {
            this.alerta("Turno guardado exitosamente!", "bien")
            this.findAllTurnos()
          })
          .catch((error) => {
            console.error(error)
            this.alerta("Error al guardar turno", "error")
          })
      },

      modify() {
        this.$axios
          .put(this.$hostname + this.$hName + "/turnos-trabajo", this.turno, {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((response) => {
            this.alerta("Turno modificado exitosamente!", "bien")
            this.findAllTurnos()
          })
          .catch((error) => {
            console.error(error)
            this.alerta("Error al modificar turno", "error")
          })
      },

      eliminar() {},

      alerta(e, l) {
        if (l === "bien") {
          this.aalert.estado = true
          this.aalert.color = "success"
          this.aalert.nombre = e

          this.newwnuevo()
        }

        if (l === "error") {
          this.aalert.estado = true
          this.aalert.color = "error"
          this.aalert.nombre = e

          this.ejecucion = false
        }
      },

      // Un metodo que se llama cuando el usuario cambia la página de la tabla.
      cargarPaginacion(e, s) {
        if (e.itemsPerPage == -1) {
          e.itemsPerPage = 15
        }
        this.paginador = JSON.parse(JSON.stringify(e))
        this.descripcion = s
        this.findAllTurnos()
      },

      findAllTurnos() {
        this.$axios
          .get(this.$hostname + this.$hName + "/turnos-trabajo", {
            headers: this.$store.getters.GetheadersAxios,
            params: {
              descripcion: this.descripcion,
              page: this.paginador.page - 1,
            },
          })
          .then((response) => {
            this.turnoList = response.data.content
            this.totalItems = response.data.totalElements
          })
          .catch((error) => {
            console.error(error)
          })
      },

      findAllDias() {
        this.$axios
          .get(this.$hostname + this.$hName + "/dias-semana", {
            headers: this.$store.getters.GetheadersAxios,
          })
          .then((response) => {
            this.diaSemanaList = response.data
          })
          .catch((error) => {
            console.error(error)
          })
      },
    },

    computed: {},
  }
</script>

<style></style>
